<ng-container>
  <div class="thumb-buttons-container">
    <mat-icon
      class="thumbUpDown"
      *ngIf="feedback?.value !== THUMB_UP && !displayThumbs"
      (mouseenter)="showThumbs()"
      (mouseleave)="hideThumbs()"
      (click)="displayThumbs = true"
    >thumbs_up_down</mat-icon>
    <div
      #iconContainer
      *ngIf="displayThumbs || feedback?.value === THUMB_UP  || isMenuOpened"
      class="icon-container"
      (mouseleave)="hideThumbs()"
      [ngClass]="{'up-selected': feedback?.value === THUMB_UP, 'mobile-show-both-btn': isMobileView && displayThumbs}"
    >
      <mojo-feedback-button
        *ngIf="feedback?.value === THUMB_UP || (showOnHover && isCandidateCardHovered) || !showOnHover || (isMobileView && displayThumbs)"
        [feedbackModel]="!!feedback ? feedback : createFeedbackModel()"
        [selected]="feedback?.value === THUMB_UP"
        [thumbValue]="THUMB_UP"
        [runConfetti]="shouldRunConfetti()"
        (thumbSent)="onThumbSent($event)"
        (mouseenter)="showThumbs()"
        (click)="displayThumbs = true"
      >
      </mojo-feedback-button>
      <mojo-feedback-button
        *ngIf="(showOnHover && isCandidateCardHovered && displayThumbs) || (isMobileView && displayThumbs) || isMenuOpened"
        [feedbackModel]="createFeedbackModel()"
        [selected]="false"
        [thumbValue]="THUMB_DOWN"
        (thumbWithReasonsSent)="onThumbWithReasons($event)"
        (isMenuOpened)="isMenuOpened=$event; feedbackPanelOpened.emit($event)"
      >
      </mojo-feedback-button>
      <div
        *ngIf="isMobileView && displayThumbs"
        mat-flat-button
        class="close-btn"
        (click)="displayThumbs = false"
      >
        <mat-icon>close</mat-icon>
      </div>
    </div>
  </div>
</ng-container>
